export function normalizeErrorMessage(data) {
  if (!data) return "Wystąpił błąd. Spróbuj ponownie.";
  if (typeof data === "string") return data;
  if (data.detail && typeof data.detail === "string") return data.detail;

  const fieldEntries = Object.entries(data)
    .map(([field, value]) => {
      if (Array.isArray(value)) return `${field}: ${value.join(" ")}`;
      if (typeof value === "string") return `${field}: ${value}`;
      return null;
    })
    .filter(Boolean);

  return fieldEntries[0] || "Nie udało się przetworzyć żądania.";
}
